import { useState } from 'react';

import PersonAcknowledgementData from './PersonAcknowledgementData';

const usePersonAcknowledgementData = () => {
  const [ personAcknowledgementState, setPersonAcknowledgementState ] = useState({...PersonAcknowledgementData.INITIAL_STATE});

  const getPersonAcknowledgements = (memberId) => {
    return PersonAcknowledgementData.getPersonAcknowledgements(memberId, personAcknowledgementState, setPersonAcknowledgementState);
  };

  const postPersonAcknowledgements = (memberId, acknowledgements) => {
    return PersonAcknowledgementData.postPersonAcknowledgements(memberId, acknowledgements, personAcknowledgementState, setPersonAcknowledgementState);
  };

  return {
    personAcknowledgementState,
    getPersonAcknowledgements,
    postPersonAcknowledgements
  };
}

export default usePersonAcknowledgementData;
